// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DoubleCard_wrapper__WmFtm","card":"DoubleCard_card__PIraV","static":"DoubleCard_static__o_rVr"};